import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('securityGroups');

export const check = () => useBasicAuth.checkToken();

export const findSecurityGroupById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllSecurityGroup = () => 
  axios.get(urlAPI + "/findAll", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllSecurityGroupByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const findAllSecurityGroupByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const addSecurityGroup = (obj) => 
  axios.post(urlAPI + "/addSecurityGroup" , JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateSecurityGroup = (obj) => 
  axios.put(urlAPI + "/updateSecurityGroup/" + obj.securityGroup.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const deleteSecurityGroup = (id) => 
  axios.delete(urlAPI + "/deleteSecurityGroup/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });



export const findAllBySecurityGroupProfile_group = (securityGroup) => 
  axios.post(urlAPI + "/securityGroupProfile/group", JSON.stringify(securityGroup), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllBySecurityGroupProfile_profile = (securityProfile) => 
  axios.post(urlAPI + "/securityGroupProfile/profile", JSON.stringify(securityProfile), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });



  export const findAllBySecurityGroupUser_group = (securityGroup) => 
    axios.post(urlAPI + "/securityGroupUser/group", JSON.stringify(securityGroup), environment.HEADER)
    .then(({data}) => data)
    .catch(e => {
      useBasicAuth.handleError(e);
    });
  
  export const findAllBySecurityGroupUser_user = (user) => 
    axios.post(urlAPI + "/securityGroupUser/user", JSON.stringify(user), environment.HEADER)
    .then(({data}) => data)
    .catch(e => {
      useBasicAuth.handleError(e);
    });